export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="relative bg-foreground-900 text-foreground-200 pt-14 md:pt-16 pb-8">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">青青草视频</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-4">
              汇聚久久视频、芒果视频、97视频、丝瓜视频等在线视频平台，提供流畅在线播放、高清视频网站体验。多平台视频资源聚合导航，一站式畅享在线视频。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 rounded-lg bg-foreground-700 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer">
                <i className="ri-arrow-up-line text-foreground-200 text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4 font-heading">快速导航</h3>
            <div className="flex flex-col gap-2.5">
              <a href="#hero" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">首页</a>
              <a href="#ranking" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热度排行</a>
              <a href="#topics" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a>
              <a href="#updates" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">最新动态</a>
              <a href="#cards" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">精选推荐</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4 font-heading">视频平台</h3>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">久久视频</span>
              <span className="text-sm text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">芒果视频</span>
              <span className="text-sm text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">97视频</span>
              <span className="text-sm text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">丝瓜视频</span>
              <span className="text-sm text-foreground-400 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">蓝莓视频</span>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-background-50 mb-4 font-heading">合作伙伴</h3>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-foreground-500">敬请期待</span>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 青青草视频. All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="inline-flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line"></i>
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}